var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "v-toolbar",
        {
          staticClass: "report_bar",
          attrs: { flat: "", dense: "", color: "blue-grey lighten-5" }
        },
        [
          _c("v-toolbar-title", [_vm._v("\n            Staff\n        ")]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.notLoggedUsers.length > 0
            ? _c(
                "v-btn",
                {
                  staticClass: "blue--text",
                  attrs: { icon: "", color: "accent-2" },
                  on: { click: _vm.openDialog }
                },
                [_c("v-icon", [_vm._v("mdi-account-clock-outline")])],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "600px" },
          on: {
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              _vm.dialog = false
            }
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { color: "lighten-1" } },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          model: {
                            value: _vm.valid,
                            callback: function($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid"
                          }
                        },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "12" } },
                                [
                                  _vm.editedIndex === -1
                                    ? _c("v-select", {
                                        attrs: {
                                          items: _vm.notLoggedUsers,
                                          "item-text": "name",
                                          "item-value": "id",
                                          placeholder: "Select someone",
                                          rules: _vm.nameRules
                                        },
                                        model: {
                                          value: _vm.editedItem.user_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "user_id",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.user_id"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "6", md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Start Time",
                                      type: "time"
                                    },
                                    model: {
                                      value: _vm.editedItem.start_time,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editedItem,
                                          "start_time",
                                          $$v
                                        )
                                      },
                                      expression: "editedItem.start_time"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "6", md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "End Time", type: "time" },
                                    model: {
                                      value: _vm.editedItem.end_time,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editedItem,
                                          "end_time",
                                          $$v
                                        )
                                      },
                                      expression: "editedItem.end_time"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "6", md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Break",
                                      type: "number",
                                      hint: "enter time in min",
                                      "persistent-hint": ""
                                    },
                                    model: {
                                      value: _vm.editedItem.break,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editedItem,
                                          "break",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "editedItem.break"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "6", md: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Not Working/Down Time",
                                      type: "number",
                                      hint: "enter time in min",
                                      "persistent-hint": ""
                                    },
                                    model: {
                                      value: _vm.editedItem.notworking,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editedItem,
                                          "notworking",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "editedItem.notworking"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "12" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      multiple: "",
                                      chips: "",
                                      items: _vm.user_tasks,
                                      "item-text": "name",
                                      "item-value": "id",
                                      placeholder: "Type in",
                                      label: "Completed tasks",
                                      "hide-no-data": "",
                                      "prepend-icon": "mdi-magnify",
                                      rules: _vm.nameRules,
                                      "return-object": false
                                    },
                                    model: {
                                      value: _vm.editedItem.tasks,
                                      callback: function($$v) {
                                        _vm.$set(_vm.editedItem, "tasks", $$v)
                                      },
                                      expression: "editedItem.tasks"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Other",
                                      "persistent-hint": "",
                                      hint: "Any other tasks not listed above"
                                    },
                                    model: {
                                      value: _vm.editedItem.other,
                                      callback: function($$v) {
                                        _vm.$set(_vm.editedItem, "other", $$v)
                                      },
                                      expression: "editedItem.other"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: { click: _vm.close }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "blue darken-1",
                        type: "submit",
                        disabled: !_vm.valid || _vm.isSubmited
                      },
                      on: { click: _vm.save }
                    },
                    [_vm._v("Save")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: { headers: _vm.headers, items: _vm.wages, "items-per-page": 10 },
        scopedSlots: _vm._u([
          {
            key: "item.actions",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "v-btn",
                  {
                    attrs: { icon: "", small: "" },
                    on: {
                      click: function($event) {
                        return _vm.edit(item)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { center: "" } }, [
                      _vm._v("mdi-pencil")
                    ])
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "item.tasks",
            fn: function(ref) {
              var item = ref.item
              return [
                _vm._l(item.tasks, function(task) {
                  return [
                    _c("span", [_vm._v(_vm._s(task.name))]),
                    _vm._v(" \n            ")
                  ]
                }),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(item.other))])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }